import * as React from "react";
import { Link } from "react-router-dom";
import { type Props } from "web-ui/components/LinkComponent";

const HrefLink = (
  { href = "", ...rest }: Props,
  ref: React.Ref<HTMLAnchorElement>,
) => <Link ref={ref} to={href} {...rest} />;

export default React.forwardRef(HrefLink);
